import script from "./login_info.vue?vue&type=script&lang=ts&setup=true"
export * from "./login_info.vue?vue&type=script&lang=ts&setup=true"

import "./login_info.vue?vue&type=style&index=0&id=56ce521a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ce521a"]])

export default __exports__